import { MultiInvestment } from '../types'

export const getMaxAppliedBonusForMulti = (
  multiInvestment: MultiInvestment,
  betSlipMultiInvestment: MultiInvestment
) => {
  const isSingleValid =
    betSlipMultiInvestment.value > 0 ||
    betSlipMultiInvestment.f2 > 0 ||
    betSlipMultiInvestment.f3 > 0 ||
    betSlipMultiInvestment.f4 > 0 ||
    betSlipMultiInvestment.f5
  if (multiInvestment.isBonusBet) {
    return multiInvestment.value
  } else if (multiInvestment.isBonusCash || betSlipMultiInvestment.isBonusCash) {
    return (
      betSlipMultiInvestment.value +
      betSlipMultiInvestment.f2 +
      betSlipMultiInvestment.f3 +
      betSlipMultiInvestment.f4 +
      betSlipMultiInvestment.f5 +
      (isSingleValid ? betSlipMultiInvestment.f1 : 0)
    )
  } else {
    return 0
  }
}
